import { IOProps } from 'react-compose-io'
import { BotaoIO } from './Botao.IO'
import { ButtonProps, CircularProgress } from '@material-ui/core'
import { ReactElement } from 'react'

export interface BotaoProps extends ButtonProps {
  textoBotao: string | JSX.Element
  icone?: ReactElement
  iconeDireita?: boolean
  estilo?: 'text' | 'contained' | 'outlined' | 'rounded'
  tamanho?: 'pequeno' | 'medio' | 'grande'
  cor?: 'primaria' | 'erro' | 'sucesso' | string
  width?: string
  margin?: string
  loading?: boolean
}

export function BotaoView({ _io, margin, textoBotao, iconeDireita, tamanho, estilo, icone, width, loading, ...rest }: IOProps<BotaoIO, BotaoProps>) {
  const { Button, ContainerIconeTexto } = _io.styles

  const renderizarConteudo = () => {
    if (loading) {
      return <CircularProgress size={24} color="inherit" />
    }

    const conteudo = iconeDireita ? (
      <>
        {icone}
        {textoBotao}
      </>
    ) : (
      <>
        {textoBotao}
        {icone}
      </>
    )

    return <ContainerIconeTexto>{conteudo}</ContainerIconeTexto>
  }

  return (
    <Button margin={margin} tamanho={tamanho} estilo={estilo} cor={_io.corBotao} width={width} {...rest} disabled={loading || rest.disabled}>
      {renderizarConteudo()}
    </Button>
  )
}
